export const PUNCHOUT_CONFIG = {
  PEAB: {
    COMPANY_NAME: 'PEAB',
    STYCK_UNIT_FORMAT: 'ST',
  },
  MALARENERGI: {
    COMPANY_NAME: 'MALARENERGI',
  },
  CRAMO: {
    COMPANY_NAME: 'CRAMO',
  },
};
